import { mainAxios } from "./axios";

class AsyncService {
	getSpadeJobStatus(id) {
		return mainAxios.get(`/async_event/spade_job/status/${id}`);
	}
}

export default new AsyncService();
